<template>
    <div class="height bg-white my-2 ml-2">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'BackgroundContainer',
}
</script>

<style lang="scss" scoped>
.height {
    min-height: calc(100vh - 167px);
}
</style>
